import Axios from 'axios';
import config from '@/config.js';
import downloadjs from 'downloadjs';
import Swal from 'sweetalert2';

const FollowUpStore = {
	namespaced: true,
	state: {
		queueFollowUp: [],
	},
	getters: {
		getQueueFollowUpByProcessId: (state) => (processId) => {
			if (!processId) return [];
			return state.queueFollowUp.filter(file => file.processId === processId);
		},
	},
	mutations: {
		SET_QUEUE_FOLLOW_UP(state, payload) {
			state.queueFollowUp = payload;
		},
		ADD_TO_QUEUE_FOLLOW_UP(state, payload) {
			state.queueFollowUp.push(payload);
		},
		REMOVE_FROM_QUEUE_FOLLOW_UP(state, taskId) {
			state.queueFollowUp = state.queueFollowUp.filter(fileMap => fileMap.taskId !== taskId);
		},
	},
	actions: {},
};

export default FollowUpStore;
